import styled from "styled-components";

import { buttonLoadingCss } from "../../components/Button";

export { Card, Container, Section } from "../Settings/styles";

export const Note = styled.p`
  color: var(--color-neutral-150);
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  line-height: 1.25rem;
`;

/** The buttons of the screen, a real <button> (reached with Tab, pressed with Enter or Space) in the look of Button INFO/MD. */
export const ActionButton = styled.button<{ $loading?: boolean }>`
  padding: 0.5rem 1rem;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1rem;
  color: var(--color-neutral-white);
  cursor: pointer;
  background-color: var(--color-brand-blue);
  border: 0;
  border-radius: 6.25rem;

  &:focus-visible {
    outline: 2px solid var(--color-neutral-white);
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
  }

  ${({ $loading }) => $loading && buttonLoadingCss}
`;

/** The button that saves the card, with how the last save went beside it. */
export const SaveRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-end;
`;

/** The page: the card in its showcase, and under it the form that personalizes it. */
export const Studio = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

/** The card in the spotlight, its wallets right under it. */
export const Showcase = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  align-items: center;
  padding: 0.5rem 0;

  /* the card's drawing, at the size it's held */
  > :first-child {
    width: 100%;
    max-width: 320px;
  }
`;

/** The name and what the person does, side by side where the form is wide. */
export const TwoFields = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.75rem;
`;

/** A block of the screen: what it is (icon, title, a line) over what is done in it. */
export const Block = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-family: Inter, sans-serif;

  .head {
    display: flex;
    gap: 0.875rem;
    align-items: flex-start;
  }

  .icon {
    display: grid;
    flex: none;
    place-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--color-neutral-base);
    color: var(--color-neutral-white);

    svg {
      width: 18px;
      height: 18px;
    }
  }

  h3 {
    margin: 0 0 0.25rem;
    color: var(--color-neutral-white);
    font-size: 0.9375rem;
    font-weight: 700;
    line-height: 1.25rem;
  }

  p {
    margin: 0;
    color: var(--color-neutral-150);
    font-size: 0.8125rem;
    line-height: 1.125rem;
  }

  .fields {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding-top: 0.25rem;
  }
`;

/** The sample card of the empty screen: dimmed, nothing on it to click. */
export const Sample = styled.div`
  opacity: 0.45;
  pointer-events: none;
  user-select: none;
`;

/** What the empty screen asks (create or publish a Keepo), with its button. */
export const EmptyCall = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  max-width: 320px;
  text-align: center;

  p {
    color: var(--color-neutral-white);
    font-family: Inter, sans-serif;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5rem;
  }
`;
